import {Injectable, Signal} from '@angular/core';
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {Brukerkontekst} from "./Brukerkontekst";
import {Observable, ReplaySubject, Subject} from "rxjs";
import {erIkkeNil} from "../støttefunksjoner/nilsjekk";
import {toSignal} from "@angular/core/rxjs-interop";

const debug = initDebugger('BrukerkontekstTilbyder');

/** Tjeneste som gir tilgang til informasjon om innlogget bruker ({@link Brukerkontekst}), dersom slik finnes. */
@Injectable({providedIn: 'root'})
export class BrukerkontekstTilbyder {

    private aktivKontekst: Brukerkontekst | null = null;
    private kontekststrøm = new ReplaySubject<Brukerkontekst>(1);
    private autentisertBrukerSignal = toSignal(this.kontekststrøm, {initialValue: null});
    private brukerLoggetUtStrøm = new Subject<void>();

    constructor() {
    }

    erAutentisert(): boolean {
        return erIkkeNil(this.aktivKontekst);
    }

    erIkkeAutentisert(): boolean {
        return !this.erAutentisert();
    }

    /** Returnerer innlogget brukers kontekst.
     * Merk at vi forutsetter at bruker er logget inn, dersom du er usikker på om dette er tilfelle MÅ du først kalle {@link #erAutentisert} */
    autentisertBruker(): Brukerkontekst {
        if (this.erIkkeAutentisert())
            throw new Error('BrukerkontekstTilbyder.autentisertBruker(): ingen autentisert bruker');

        return this.aktivKontekst!;
    }

    /** Returnerer innlogget brukers kontekst. */
    autentisertBrukerSomStrøm(): Observable<Brukerkontekst> {
        return this.kontekststrøm;
    }

    /** Returnerer innlogget brukers kontekst. */
    get autentisertBrukerSomSignal(): Signal<Brukerkontekst | null> {
        return this.autentisertBrukerSignal;
    }

    /** Strøm som signaliserer når bruker logger ut. */
    brukerLoggetUtSomStrøm(): Observable<void> {
        return this.brukerLoggetUtStrøm;
    }


    //mutering

    /** For intern bruk */
    setAutentisertBruker(kontekst: Brukerkontekst) {
        debug('setAutentisertBruker', kontekst)
        this.aktivKontekst = kontekst;
        this.kontekststrøm.next(this.aktivKontekst);
    }


    /** For intern bruk.
     * markerer at bruker har logget ut */
    setBrukerLoggetUt() {
        debug('setBrukerLoggetUt')
        this.aktivKontekst = null;
        this.brukerLoggetUtStrøm.next();
    }

    //hjelpemetoder

}
